import Pagination from '@mui/material/Pagination';
import React, { useEffect, useState } from 'react';
import { ApiCall, NotificationSound, currentDate, getBeforeDate, handleDateChange, setFocus } from '../../Common/Common';
import { CustomButton, DateBox } from '../../Common/Input';

const BankStatementReport = () => {
    const initialState = {
        DateFrom: getBeforeDate(7),
        DateTo: currentDate(),
    }
    const [formData, setFormData] = useState(initialState);
    const [tableLoading, setTableLoading] = useState(false);
    const [tableData, setTableData] = useState(null);
    const [sortConfig, setSortConfig] = useState({ sortColumn: null, sortOrder: null });
    const [tableSearchClick, setTableSearchClick] = useState(true);
    //....... Pagination Start ........
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const trnXnDetails = tableData?.Acc_Stmt_DtRng_Res?.Body?.transactionDetails;
    const totalPages = Math.ceil(trnXnDetails?.length / pageSize);

    const startIndex = (currentPageNo - 1) * pageSize;
    const currentItems = trnXnDetails?.slice(startIndex, startIndex + pageSize);

    //....... Pagination End ........

    const handleChange = (event, pagenumber) => {
        setCurrentPageNo(pagenumber)
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const getIncompleteRegistrations = async (request = formData) => {
       
        setTableLoading(true)
        let response = await ApiCall(`/api/Payment/StatementReport`, { ...request })
        if (response?.Acc_Stmt_DtRng_Res?.Header?.Status === 'SUCCESS') {
            setTableData(response);
            setTableLoading(false)
        } else if (response?.Acc_Stmt_DtRng_Res?.Header?.Status === "FAILED") {
            setTableData(null);
            setTableLoading(false)
            NotificationSound("Error", response?.Acc_Stmt_DtRng_Res?.Header?.Error_Desc, response.focus)
        } 
    }

    useEffect(() => {
        document.title = 'Bank Statement Report'
       // getIncompleteRegistrations()
    }, [])

    return (
        <>

            <div className="my-5 rounded-xl border bg-white p-3">
                <div className="grid-cols-1 grid gap-2 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
                    <DateBox
                        id='txtDateFrom'
                        label='Date From'
                        placeholder='Date From'
                        selected={formData.DateFrom === '' ? '' : new Date(formData.DateFrom)}
                        onChange={(e) => handleDateChange(e, setFormData, formData, 'DateFrom')}
                        autoComplete="off"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                setFocus('txtDateTo')
                            }
                        }}
                    />
                    <DateBox
                        id='txtDateTo'
                        label='Date To'
                        placeholder='Date To'
                        selected={formData.DateTo === '' ? '' : new Date(formData.DateTo)}
                        onChange={(e) => handleDateChange(e, setFormData, formData, 'DateTo')}
                        autoComplete="off"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                setFocus('txtUserName')
                            }
                        }}
                    />
                </div>
                <div className="mt-3 flex items-center gap-3">
                    <CustomButton
                        label='Search'
                        id={'btn_Save'}
                        color={'yellow'}
                        onClick={() => {
                        setTableSearchClick(false)
                        getIncompleteRegistrations()
                        } 
                    }
                    />
                    <CustomButton
                        label='Reset'
                        id={'btn_Reset'}
                        color={'red'}
                        onClick={() => {
                            setFormData(initialState)
                            getIncompleteRegistrations(initialState)
                        }}
                    /> 
                </div>
            </div>
            {
                tableLoading ? <div className="mt-5 rounded-xl border bg-white p-3">
                    <div className="relative min-h-[350px] w-full">
                        <div className='-translate-x-2/4 -translate-y-2/4 absolute left-2/4 top-2/4 flex items-center justify-center'>
                            <div
                                className="h-12 w-12 animate-spin rounded-full border-y border-solid border-cyan-500 border-t-transparent shadow-md">
                            </div>
                        </div>
                    </div>
                </div>
                    :
                    <>
                        {
                            tableData !== null ?
                                <div className="mt-5 rounded-xl border bg-white p-3">
                                    {
                                        !tableLoading &&
                                        <div className='flex items-center justify-between'>
                                            <div className=' mb-1 flex items-center gap-2'>
                                                <h6 className='mb-sm-0 font-weight-bold m-0' style={{ color: '#4E2D87' }}>
                                                    <span>{`${'Total Available Balance : ' + tableData?.Acc_Stmt_DtRng_Res?.Body?.accountBalances?.availableBalance?.amountValue}`}</span>
                                                </h6>
                                                {/*<div*/}
                                                {/*    onClick={handleDownLoadExcel}*/}
                                                {/*    className="m-0 flex cursor-pointer items-center justify-center rounded-full bg-black px-3 py-1.5 text-sm font-semibold leading-none text-white"*/}
                                                {/*>*/}
                                                {/*    <span className="me-2"><i className="fa fa-download"></i>*/}
                                                {/*    </span>Export*/}
                                                {/*</div>*/}
                                            </div>
                                            {/* Filter and Advance Filter Icon and paging*/}
                                            <div className={`mb-1`}>
                                                <div className="flex">
                                                    <div className='ps-3'>
                                                        <select
                                                            className="block h-[31px] w-fit rounded-lg border border-gray-300 bg-gray-50 px-2.5 py-1.5 text-sm text-gray-900 focus:ring-blue-500 focus:border-blue-500 focus:outline-none 2xl:py-1.5 2xl:px-2.5"
                                                            aria-label="PageSize"
                                                            value={pageSize}
                                                            onChange={(e) => setPageSize(e.target.value)}
                                                        >
                                                            <option value="10">10</option>
                                                            <option value="20">20</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="200">200</option>
                                                            <option value="500">500</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <table className="common-table">
                                        <thead>
                                            <tr>
                                                <th>
                                                    Transaction Amount
                                                    {/*<>*/}
                                                    {/*    <i className="fa fa-arrow-up ms-2 cursor-pointer" style={{ color: '#d4d4d4', fontSize: "14px" }} onClick={() =>*/}
                                                    {/*        handleSorting && handleSorting('UserCode')}></i>*/}
                                                    {/*    <i className="fa fa-arrow-down cursor-pointer" style={{ color: '#d4d4d4', fontSize: "14px" }} onClick={() =>*/}
                                                    {/*        handleSorting && handleSorting('UserCode')} ></i>*/}
                                                    {/*</>*/}
                                                </th>
                                                <th>
                                                    Transaction Date
                                                    {/*<>*/}
                                                    {/*    <i className="fa fa-arrow-up ms-2 cursor-pointer" style={{ color: '#d4d4d4', fontSize: "14px" }} onClick={() =>*/}
                                                    {/*        handleSorting && handleSorting('Phone')}></i>*/}
                                                    {/*    <i className="fa fa-arrow-down cursor-pointer" style={{ color: '#d4d4d4', fontSize: "14px" }} onClick={() =>*/}
                                                    {/*        handleSorting && handleSorting('Phone')} ></i>*/}
                                                    {/*</>*/}
                                                </th>
                                                <th>
                                                    Transaction Description
                                                    {/*<>*/}
                                                    {/*    <i className="fa fa-arrow-up ms-2 cursor-pointer" style={{ color: '#d4d4d4', fontSize: "14px" }} onClick={() =>*/}
                                                    {/*        handleSorting && handleSorting('PersonalInformation')}></i>*/}
                                                    {/*    <i className="fa fa-arrow-down cursor-pointer" style={{ color: '#d4d4d4', fontSize: "14px" }} onClick={() =>*/}
                                                    {/*        handleSorting && handleSorting('PersonalInformation')} ></i>*/}
                                                    {/*</>*/}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                currentItems?.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className='text-sm font-normal text-zinc-700'>{item?.transactionSummary?.txnAmt?.amountValue}</td>
                                                        <td className="text-sm font-normal text-zinc-700">
                                                            {item?.transactionSummary?.txnDate
                                                                ? new Date(item.transactionSummary.txnDate).toLocaleString("en-GB", {
                                                                    day: "2-digit",
                                                                    month: "2-digit",
                                                                    year: "numeric",
                                                                    hour: "2-digit",
                                                                    minute: "2-digit",
                                                                    second: "2-digit",
                                                                })
                                                                : ""}
                                                        </td>
                                                        <td className='text-sm font-normal text-zinc-700'>{item?.transactionSummary?.txnDesc}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                    {trnXnDetails?.length > 10 && (
                                        <div className="mt-4 flex items-center justify-between">

                                            <h6 className='mb-sm-0 font-weight-bold m-0'>
                                                <span>{`${tableData?.Acc_Stmt_DtRng_Res?.Body?.transactionDetails?.length !== undefined ? 'Total Records : ' + tableData?.Acc_Stmt_DtRng_Res?.Body?.transactionDetails?.length : 'No Record Found'}`}</span>
                                            </h6>
                                            <div>
                                                Showing page {currentPageNo} of {totalPages}
                                            </div>
                                            <Pagination
                                                count={totalPages}
                                                page={currentPageNo}
                                                onChange={handleChange}
                                                size="small"
                                                variant="outlined"
                                            />
                                        </div>
                                    )}
                                </div> :

                                <div className="my-5 rounded-xl border bg-white p-3">
                                    <div className='flex items-center justify-center gap-2'>
                                        <h6 className='mb-sm-0 font-weight-bold m-0' style={{ color: '#4E2D87' }}>
                                            <span>{tableSearchClick ? "Please Search":'No Record Found '}</span>
                                        </h6>
                                    </div>
                                </div>
                        }
                    </>

            }
        </>
    )
}

export default BankStatementReport



